import { Injectable } from '@angular/core';
import * as emoji from 'node-emoji';

@Injectable({
  providedIn: 'root',
})
export class ChatEmojiService {
  private path: string;

  emojify(message: string): string {
    return emoji.emojify(message, this.onMissing, this.format);
  }

  getEmoji(text: string): string {
    return emoji.emojify(':' + text + ':', this.onMissing, this.format);
  }

  private format(_code, name) {
    let emojiList = [
      'slightly_smiling_face',
      'wink',
      '+1',
      'grinning',
      'sunglasses',
      'thinking_face',
      'pensive',
      'hushed',
      'cloud',
      'sunny',
    ];
    for (const emojiName of emojiList) {
      if (emojiName === name) {
        return '<img loading="lazy" alt="' + name + '" src="/front/assets/images/emojis/' + name + '.png" class="emoji" />';
      }
    }
    return ':' + name + ':';
  }

  private onMissing(name) {
    return ':' + name + ':';
  }
}
